import { DocPerClaimTypeGetAdapter } from '../../../adapter';

export default async function DocPerClaimTypeGetUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/document-per-claim-type/get'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/document-per-claim-type/get'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/document-per-claim-type/get`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/document-per-claim-type/get`;
    // prepare data
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/document-per-claim-type/get';

    const payload = {};

    // handle request
    const result = await DocPerClaimTypeGetAdapter(endpoint, JSON.stringify(payload));

    return result;
}
